export default {
  allEmployees: [],
  employee: {},
}
